import { render, staticRenderFns } from "./inventory-node-form.vue?vue&type=template&id=564dac02"
import script from "./inventory-node-form.vue?vue&type=script&lang=js"
export * from "./inventory-node-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports